import { render, staticRenderFns } from "./k-menu.vue?vue&type=template&id=0d3acb87&"
import script from "./k-menu.vue?vue&type=script&lang=ts&"
export * from "./k-menu.vue?vue&type=script&lang=ts&"
import style0 from "./k-menu.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports